// extracted by mini-css-extract-plugin
export var FAQAccordion = "index-module--FAQAccordion--K7XfF";
export var answer = "index-module--answer--K03DW";
export var answercontainer = "index-module--answercontainer--7+ZIX";
export var faq = "index-module--faq--hFf4E";
export var linkhover = "index-module--linkhover--+nLue";
export var list = "index-module--list--EIxor";
export var toggle = "index-module--toggle--aA5iC";
export var toggleactive = "index-module--toggleactive--ud9Nc";